// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import { ElMessage } from 'element-plus';
import Consent from '@/views/Consent.vue';
import Survey from '@/components/Survey.vue';
import Qianming from '@/components/Qianming.vue';
import Qianming01 from '@/components/Qianming01.vue';
import Bingli from '@/views/Bingli.vue';
import Xinxi from '@/views/Xinxi.vue';
import Denglu from '@/views/Denglu.vue';
import Yishengshenhe from '@/views/Yishengshenhe.vue';
import ApplicationDetail from '@/views/ApplicationDetail.vue';
import { setToken, getToken } from '@/utils/auth'; 
import store from '@/store';

// 1. 定义路由规则
const routes = [
    {
        path: '/',
        name: 'login',
        component: Denglu,
        // 修复：将 'mata' 改为 'meta'
        meta: { requiresAuth: false } 
    },
    {
        path: '/denglu',
        name: 'Denglu',
        component: Denglu,
        meta: { requiresAuth: false }
    },
    {
        path: '/survey',
        name: 'Survey',
        component: Survey,
        meta: {
            requiresAuth: true,
            roles: ['student']
        }
    },
    {
        path: '/qianming',
        name: 'Qianming',
        component: Qianming,
        meta: { requiresAuth: true }
    },
    {
        path: '/qianming01',
        name: 'Qianming01',
        component: Qianming01,
        meta: { requiresAuth: true }
    },
    {
        path: '/bingli',
        name: 'Bingli',
        component: Bingli,
        meta: { requiresAuth: true }
    },
    {
        path: '/xinxi',
        name: 'Xinxi',
        component: Xinxi,
        meta: { requiresAuth: true }
    },
    {
        path: '/consent',
        name: 'Consent',
        component: Consent,
        meta: { requiresAuth: true }
    },
    {
        path: '/yishengshenhe',
        name: 'Yishengshenhe',
        component: Yishengshenhe,
        meta: {
            requiresAuth: true,
            roles: ['doctor']
        }
    },
    {
        path: '/applicationDetail',
        name: 'ApplicationDetail',
        component: ApplicationDetail,
        meta: { requiresAuth: true }
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/denglu'
    }
];

// 2. 创建 router 实例
const router = createRouter({
    history: createWebHistory(), // 使用 history 模式
    routes // 应用路由规则
});

// src/router/index.js 路由守卫部分
router.beforeEach((to, from, next) => {
  // 1. 不需要登录的路由（登录页）
  if (!to.meta.requiresAuth) {
    const token = getToken();
    if (token) {
      // 读取 userInfo 时增加容错
      let userInfo = {};
      try {
        userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      } catch (e) {
        userInfo = {}; // 解析失败时默认空对象
      }
      const homePath = userInfo.role === 'doctor' ? '/yishengshenhe' : '/survey';
      // 避免从登录页跳首页时触发循环
      if (from.path !== homePath) {
        setTimeout(() => next(homePath), 100);
      } else {
        next(false); // 防止重复跳转
      }
    } else {
      next();
    }
    return;
  }

  // 2. 需要登录的路由：读取 Token 和角色（增加容错）
  setTimeout(() => {
    const token = getToken();
    let userInfo = {};
    try {
      userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    } catch (e) {
      console.error('userInfo 解析失败:', e);
      userInfo = {};
    }
    const userRoles = userInfo.role ? [userInfo.role] : store.getters.userRoles || [];

    console.log('守卫 Token:', token);
    console.log('守卫角色:', userRoles);
    console.log('当前路径:', to.path);
    console.log('来源路径:', from.path);

    // 3. Token 不存在：跳登录页（终止循环）
    if (!token) {
      ElMessage.warning('请先登录');
      // 避免从登录页跳转时循环
      if (to.path !== '/denglu') {
        next('/denglu');
      } else {
        next(false);
      }
      return;
    }

    // 4. 角色校验（核心修复：避免无限跳转）
    if (to.meta.roles && to.meta.roles.length > 0) {
      const hasPermission = to.meta.roles.some(role => userRoles.includes(role));
      if (!hasPermission) {
        ElMessage.error('无权限访问该页面，将跳转到您的首页');
        const homePath = userRoles.includes('doctor') ? '/yishengshenhe' : '/survey';
        // 关键：如果已经在首页，直接终止跳转，避免循环
        if (from.path === homePath) {
          next(false);
        } else {
          next(homePath);
        }
        return;
      }
    }

    // 5. 所有校验通过
    next();
  }, 200);
});

// 4. 导出 router 实例
export default router;